import axios from "axios";
const instance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_ADDRESS,
  timeout: 30000,
});

export { instance as default };
